<template>
  <section>
    <PageTitle guest>
      <Logo />
    </PageTitle>
    <PageContent>
      <form @submit.prevent="submit" ref="form" method="post">
        <Container>
          <Headline :level="2">連携アプリへのログイン</Headline>
          <div class="form-group">
            <p class="text-paragraph text-xs">
              お客様のアカウントで連携アプリへログインを行います。メールアドレスとパスワードをご入力ください。
            </p>
            <p class="text-paragraph text-xs">
              こちらのページはブックマークしないでください。
            </p>
            <p class="text-paragraph text-xs">
              ブックマークされる場合は、<a href="/">こちら</a>をブックマークしてください。
            </p>
            <p class="text-paragraph text-xs indention">
              <a href="https://analysys.co.jp/login_help/" target="_blank" rel="noopener noreferrer">■WPS 利用環境のご案内■</a>
            </p>
            <p class="other-help-show text-paragraph text-xs">
                <a href="https://analysys.co.jp/other_login_help/" target="_blank" rel="noopener noreferrer">■その他の利用環境のご案内■</a>
            </p>
          </div>
          <NoticeBox type="error" v-if="hasAuthError">
            {{ authErrorMessage }}
          </NoticeBox>
          <NoticeBox type="error" v-if="hasErrors">
            {{ invalidMessage }}
          </NoticeBox>
          <div class="form-group">
            <label for="email">メールアドレス</label>
            <input
              id="email"
              name="username"
              type="text"
              class="form-control"
              :class="{ 'has-error': hasError('email') || hasAuthError }"
              v-model="email"
            />
            <FormError v-if="errors.email" :errors="errors.email" />
          </div>
          <div class="form-group">
            <label for="password">パスワード</label>
            <input
              id="password"
              name="password"
              type="password"
              class="form-control"
              :class="{ 'has-error': hasError('password') || hasAuthError }"
              v-model="password"
            />
            <FormError v-if="errors.password" :errors="errors.password" />
            <p class="form-memo text-right">
              <router-link
                :to="$wcRouter.path({ name: 'auth.forgot-password' })"
              >
                パスワードをお忘れの方はこちら
              </router-link>
            </p>
            <p class="form-memo text-right form-id-reissue">
              <a onclick="window.open(window.getComputedStyle(document.getElementById(&quot;reissue-url&quot;), &quot;before&quot;).getPropertyValue(&quot;content&quot;).replaceAll(&quot;\&quot;&quot;, &quot;&quot;));"></a>
              <span id="reissue-url"></span>
            </p>
          </div>

          <input type="hidden" name="location" v-model="location" />
          <input type="hidden" name="cognito_base_uri" v-model="cognito_base_uri" />
          <input type="hidden" name="login_uri" v-model="login_uri" />
          <input type="hidden" name="scope" v-model="scope" />

          <div class="form-footer text-center">
            <WaveButton type="submit" :disabled="$store.state.app.loading">
              ログイン
            </WaveButton>
          </div>
        </Container>
      </form>
    </PageContent>
  </section>
</template>

<script>
import { API } from 'aws-amplify'
import NoticeBox from '@/components/NoticeBox.vue'
import FormError from '@/components/FormError.vue'
import validationMixin from '@/mixins/validation'
import { AUTH_LOGIN_FAILED } from '@/messages/errors'

const STORAGE_KEY_EMAIL = 'we-connect-oauth2-login-email'

export default {
  components: {
    NoticeBox,
    FormError
  },
  rules: {
    email: ['メールアドレス', ['required']],
    password: ['パスワード', ['required']]
  },
  navbar: false,
  metaInfo() {
    return {
      title: '連携アプリへのログイン',
      bodyAttrs: { class: 'login' }
    }
  },
  data() {
    return {
      email: '',
      password: '',
      location: '',
      cognito_base_uri: '',
      login_uri: '',
      scope: '',
      authErrorMessage: AUTH_LOGIN_FAILED,
      hasAuthError: false
    }
  },
  methods: {
    async submit() {
      if (this.$store.state.app.loading) {
        return false
      }

      this.hasAuthError = false
      this.email = this.email.trim();

      if (!this.validate()) {
        return false
      }

      this.$store.commit('app/START_LOADING')

      this.saveEmail()

      const endpoint = await API.endpoint('WeConnect')
      this.$refs.form.setAttribute('action', `${endpoint}/oauth2/login`)
      this.$refs.form.submit()
    },
    restoreEmail() {
      return localStorage.getItem(STORAGE_KEY_EMAIL)
    },
    saveEmail() {
      localStorage.setItem(STORAGE_KEY_EMAIL, this.email)
    },
    deleteEmail() {
      localStorage.removeItem(STORAGE_KEY_EMAIL)
    }
  },
  created() {
    // クエリパラメータから送信値をセット
    this.cognito_base_uri = this.$route.query.cognito_base_uri
    this.login_uri = this.$route.query.login_uri
    this.scope = this.$route.query.scope
    this.location = location.href

    // ログインエラーから302で戻ってきた場合
    if (this.$route.query.is_login_error === 'true') {
      this.hasAuthError = true
      this.deleteEmail()
    }

    // メアド補完
    const savedEmail = this.restoreEmail()
    if (savedEmail) {
      this.email = savedEmail
    }
  },
  mixins: [validationMixin]
}
</script>

<style>
.other-help-show {
  display: none;
}
</style>

<style scoped>
.indention {
  margin-top: 14px;
}
</style>
